import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/Explorer/ctx/icons.styled.ts";

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var IconWrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  opacity: 0.5;\n  display: inline-flex;\n  min-width: 24px;\n  flex-shrink: 0;\n  color: #00003d;\n  li:hover & {\n    opacity: 1;\n  }\n"])));